/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated';
import { RangeDependencies } from './dependenciesRangeClass.generated';
import { sizeDependencies } from './dependenciesSize.generated';
import { createIndexNode } from '../../factoriesAny.js';
export var IndexNodeDependencies = {
  NodeDependencies: NodeDependencies,
  RangeDependencies: RangeDependencies,
  sizeDependencies: sizeDependencies,
  createIndexNode: createIndexNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesIndexNode.generated.js
// module id = 506
// module chunks = 0